import React from 'react';
import styled from 'styled-components';
import SelectBox from '../../shared/component/SelectBox';
import { MemberCreditData } from '../../shared/dto/EntityRepository';

const MIXED = 'mixed';
const NONE = 'none';

type MemberCreditSelectValue = number | typeof MIXED | typeof NONE;

interface MemberCreditSelectProps {
  value: number | null | undefined;
  credits: MemberCreditData[];
  onChange: (creditId: number | null) => void;
}

const MemberCreditSelect: React.FC<MemberCreditSelectProps> = ({
  value,
  credits,
  onChange,
}) => {
  const selectedValue: MemberCreditSelectValue =
    value === undefined ? MIXED : value ?? NONE;
  const options: MemberCreditSelectValue[] = [
    ...(value === undefined ? [MIXED] as const : []),
    NONE,
    ...credits.map((credit) => credit.id),
  ];

  const getLabel = (option: MemberCreditSelectValue) => {
    if (option === MIXED) return 'Mixed';
    if (option === NONE) return 'None';
    return credits.find((credit) => credit.id === option)?.name ?? '';
  };

  return (
    <SelectWrapper>
      <SelectBox
        value={selectedValue}
        options={options}
        handleChange={(next) => {
          if (next === MIXED) return;
          onChange(next === NONE ? null : next);
        }}
        direction={false}
        getDisplayText={getLabel}
        getOptionDisplayText={getLabel}
        isOptionDisabled={(option) => {
          if (option === MIXED) return true;
          if (option === NONE) return false;
          const credit = credits.find((each) => each.id === option);
          return !!credit && !credit.visible && credit.id !== value;
        }}
      />
    </SelectWrapper>
  );
};

export default MemberCreditSelect;

const SelectWrapper = styled.div`
  width: clamp(120px, 8vw, 150px);
  color: ${({ theme }) => theme.colors.color_Gray_04};
  ${({ theme }) => theme.typography.Body_04};
`;
